/// <reference path="../_all.ts" />

module misc {

  youTubeOverlayDirective.$inject = ['$mdDialog', ];
  

  export function youTubeOverlayDirective(
    $mdDialog : ng.material.IDialogService
  ): ng.IDirective {

    return {
      restrict: 'A',
      link: function (scope: any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        
        var toolbar: string = "<md-dialog class='youtube-overlay'><md-toolbar class='youtube-overlay-toolbar'><div class='md-toolbar-tools'><span flex></span><md-button class='md-icon-button close' ng-click='close();' aria-label='Close'><svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='/res/svg/sprite.svg?[:$CacheVersion:]#plus'></use></svg></md-button></div></md-toolbar>";
        var containerleft: string = "<md-dialog-content><div ng-click='close()' class='youtube-overlay-container'>";
        var iframe = "<iframe width=\"100%\" height=\"100%\" src=\"https://www.youtube.com/embed/VIDEOID?autoplay=1&modestbranding=1&rel=0&fs=1\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        var containerright: string = "</div></md-dialog-content></md-dialog>";

        
        element.on("click", (ev: JQueryEventObject) => {

          iframe = iframe.replace("VIDEOID", attr.youTubeOverlay);
          

          $mdDialog.show(<ng.material.IDialogOptions>{
            controller: () => { },
            scope: angular.extend(scope.$new(), {
              close: function () { $mdDialog.hide(); }
            }),
            template: toolbar  + containerleft + iframe + containerright,
            //parent: element,
            bindToController: true,
            targetEvent: <any>ev,
            clickOutsideToClose: true,
            fullscreen: true, // Only for -xs, -sm breakpoints.
            locals: {
            },
          })
        });        
      }
    }

  }
}